import React, { memo, useCallback, useEffect, useRef } from "react";
import ReactECharts from 'echarts-for-react';

import { formatTableData } from "../../utils/Reusables";

const BarChartNew = ({isLoading,resultSet,query,updateQuery,reportDetails}) => {
    const tableColumns = reportDetails.fields
    const tablePivots = formatTableData(resultSet.tablePivot(),tableColumns)
    console.log(tableColumns,tablePivots,resultSet.series())
    const options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: 'Direct',
            type: 'bar',
            barWidth: '60%',
            data: [10, 52, 200, 334, 390, 330, 220]
          }
        ]
      };

    return <ReactECharts 
        option={options}
        style={{width: '100%'}}
        notMerge={true}
        lazyUpdate={true}
        opts={{renderer: 'svg'}}
    />
}

export default memo(BarChartNew)